import '@x/lib/src/dayjs';
import '@x/lib/src/gainsight';
import { ErrorBoundary } from 'ErrorBoundary';
import { ErrorFallback } from 'ErrorFallback';
import 'lib/exposeLibs';
import { AppProviders } from 'providers';
import { createRoot } from 'react-dom/client';
import { ReactQueryDevtools } from 'react-query/devtools';
import { history } from 'stores';
import App from './App';
import './styles/index.less';

const root = createRoot(document.getElementById('root') as HTMLDivElement);

root.render(
  <AppProviders history={history}>
    <ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </ErrorBoundary>
    <ReactQueryDevtools initialIsOpen={false} />
  </AppProviders>,
);
